import { Inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BehaviorSubject, EMPTY, Subject, Subscription } from 'rxjs';
import { catchError, exhaustMap, map, finalize } from 'rxjs/operators';

import { ResponseHandler } from '../helper/ResponseHandler';
import { SecurityService } from './security.service';
import { UserService } from './user.service';
import { WebStorageService } from './webstorage.service';
import { ProfileInfoService } from 'src/app/_core/services/profile-info.service';
import { HubManager } from 'src/app/pages/hubs/common/HubManager';
import { HubService } from 'src/app/pages/hubs/common/HubService';
import { QueuesService } from './queues.service';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { WindowsWrapper } from '../../app.config';
import { HeartbeatService } from './heartbeat.service';
import { TabKeepAliveService } from './TabKeepAlive.service';
declare let $: any;
let blockGetUserCalls = false;
let getUserErrorCount = 0;
let getUser400ErrorCount = 0;
let getUserLastPingExceedCount = 0;
let requiredtoCheckallCondition = true;
let TMHubJoinFailed = 0;
let TMHubJoinSuccess = 0;
@Injectable({
    providedIn: 'root',
})
export class AppService {
    userIntervelValue: any;
    constructor(
        private userService: UserService,
        private securityService: SecurityService,
        private webStorageService: WebStorageService,
        private ProfileInfo: ProfileInfoService,
        private hubService: HubService,
        private hubManager: HubManager,
        private confirmDialogComponent: ConfirmDialogComponent,
        private queueServices: QueuesService,
        private heartbeat: HeartbeatService,
        private keepAlive: TabKeepAliveService,
        @Inject(WindowsWrapper) private OnvidaWrapper: any
    ) {
        // exhaustMap drops a getUser() trigger if the previous getUserPing call is still in flight
        //this.getUserSub = this.getUserTrigger$.pipe(
        //    exhaustMap(() => this.userService.getUserPing(false, '', getUserLastPingExceedCount, requiredtoCheckallCondition))
        //).subscribe(data => this.successCallback(data), this.errorCallback.bind(this));

        //this.getUserSub = this.getUserTrigger$.pipe(exhaustMap(() => {
        //        this.getUserRequestActive = true;
        //        return this.userService.getUserPing(false, '', getUserLastPingExceedCount, requiredtoCheckallCondition).pipe(
        //                finalize(() => {
        //                    this.getUserRequestActive = false;
        //                    this.heartbeat.requestCompleted();
        //                })
        //            );
        //    })
        //).subscribe(data => this.successCallback(data), this.errorCallback.bind(this));
        window.addEventListener('online', this.onlineHandler);
        window.addEventListener('offline', this.offlineHandler);
        this.getUserSub = this.getUserTrigger$.pipe(
            exhaustMap(() => {

                this.getUserRequestActive = true;

                return this.userService
                    .getUserPing(
                        false,
                        '',
                        getUserLastPingExceedCount,
                        requiredtoCheckallCondition
                    )
                    .pipe(
                        // Handle the error HERE so the outer subscription survives.
                        catchError((err: any) => {
                            try {
                                const errorCode =
                                    (err?.status ?? err?.message ?? err ?? '').toString();

                                this.errorCallback(errorCode, err);
                            } catch (e) {
                                console.error('[getUser] errorCallback threw:', e);
                            }

                            return EMPTY;      // swallow - outer stream stays alive
                        }),

                        finalize(() => {
                            this.getUserRequestActive = false;
                            this.heartbeat.requestCompleted();
                        })
                    );
            })
        ).subscribe(
            data => this.successCallback(data)
            // no error handler - errors can no longer reach here
        );
    }

    private getUserTrigger$ = new Subject<void>();
    private getUserSub: Subscription;
    private getUserRequestActive = false;
    modifiedQueueData: any;
    public currentMenu: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public selectedQueueId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public selectedQueueName: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public selectedQueueType: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public ttsPlaying: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public selectedCampaignId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public selectedCampaignName: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public transferCaseID: BehaviorSubject<any> = new BehaviorSubject<number>(null);
    public updatedImageURL: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public activityId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public actionItemId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public isMenulinkClicked: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public isRecordingAgentScreen: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    private queueInfoSource = new BehaviorSubject<string | null>(null);
    public numberPadValue: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public isSoftPhoneUsed: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public isConfirmed: boolean = false;
    public TransriptTab: BehaviorSubject<any> = new BehaviorSubject<any>(true);
    public TranscriptDetails: BehaviorSubject<any> = new BehaviorSubject<any>({ interactionId: null, isPostcalltranscription: false });
    public isCaseEdit: BehaviorSubject<any> = new BehaviorSubject<any>(true);
    public casesReload: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public isAddNewUser: boolean = false;
    public Trigger_ClearoldCases = new BehaviorSubject<any>(null);
    // public auditChangeSource = new BehaviorSubject<string | null>(null);
    // auditChanged$ = this.auditChangeSource.asObservable();
    infoCurrentQueue = this.queueInfoSource.asObservable();
    dispositionPayload: any;
    dispositionNotes: any = '';
    lookUpMemberId: any = [];
    editedCases: any = [];
    notesData: any = [];
    documentData: any = [];
    datePickerData: any = [];
    searchParameters: any;
    getUserInterval: any = '';
    TMHubJoined: boolean = false;
    LastGetUsercalledtime: any;
    getusercalledcount = 0;
    isMachineDetection: boolean = false;
    isUserloggedout: boolean = true;
    pagenames: string[] = ['casedetails', 'inbound', 'outbound', 'search']; // your array list
    defaultgetusertimerValue: number = 10000; // default interval in ms
    private hasOpenedQNX = false;
    public CaseUserDetail: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public TranscriptEvents = this.TransriptTab.asObservable();
    public aiAuditEnabled: BehaviorSubject<any> = new BehaviorSubject<any>(
        sessionStorage.getItem('aiAuditEnabled') === 'true'
    );
    public enableTemplateButton: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public enableAICaseNotesTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    public caseDirtyStateCache: Map<any, boolean> = new Map();
    private networkFailureCount = 0;
    private networkOfflineTimer: any = null;

    /**
     * Remains true after the network alert is shown.
     * It is reset only when connectivity returns.
     */
    private networkAlertShown = false;
    /**
     * Tracks status-0 or browser-offline connectivity problems.
     */
    private networkIssueActive = false;

    /** Prevents multiple network dialogs from being opened simultaneously. */
    private networkAlertDialogOpen = false;

    /**
     * Show the network alert after 5 minutes.
     */
    private readonly NETWORK_ALERT_DELAY_MS = 5 * 60 * 1000;
    // notifyAuditChange(interactionId: string) {
    //   this.auditChangeSource.next(interactionId);
    // }
    setUseSoftPhone(value: any) {
        this.isSoftPhoneUsed.next(value);
    }
    setNotesData(value: any) {
        if (this.notesData.length > 0 && value) {
            this.notesData = this.notesData.filter(el => el.caseId != value.caseId);
            this.notesData.push(value);
        } else {
            if (value) this.notesData.push(value); else this.notesData = [];
        }
        // this.notesData = value;
    }
    setDocumentData(value: any) {
        if (this.documentData.length > 0 && value) {
            this.documentData = this.documentData.filter(el => el.caseId != value.caseId);
            this.documentData.push(value);
        } else {
            if (value) this.documentData.push(value); else this.documentData = [];
        }
    }
    setDateTimePickerData(value: any) {
        if (this.datePickerData.length > 0 && value) {
            let flag = false;
            this.datePickerData.forEach((item) => {
                if (item.tabName == value.tabName &&
                    item.caseId === value.caseId &&
                    item.fieldName === value.fieldName) {
                    flag = true;
                    item.dateValue = value.dateValue;
                    item.convertedDateValue = value.convertedDateValue;
                }
            });
            if (!flag)
                this.datePickerData.push(value);
        } else {
            if (value) this.datePickerData.push(value); else this.datePickerData = [];
        }
    }
    getNotesData() {
        return this.notesData;
    }
    getDocumentData() {
        return this.documentData;
    }
    getDateTimePickerData() {
        return this.datePickerData;
    }
    setNumberpadValue(value: any) {
        this.numberPadValue.next(value);
    }

    setEditedCases(value: any) {
        this.editedCases = value;
    }
    setTrigger_ClearoldCases(value: any) {
        this.Trigger_ClearoldCases.next(value);
    }
    getEditedCases() {
        if (this.editedCases != null && this.editedCases != undefined && this.editedCases.length > 0) {
            let editedCases = this.editedCases.filter(item => item.CaseID !== '' && item.CaseID !== null && item.CaseID !== undefined && item.CaseID.trim() !== '');
            return editedCases;
        }
        return this.editedCases;
    }

    setLookUpMemberId(value: any) {
        let isPresent = false;
        this.lookUpMemberId?.forEach(el => {
            if (el.caseId == value.caseId && el.fieldID == value.fieldID && el.fieldName == value.fieldName) {
                el.findMemberId = value.findMemberId ?? value.findMemberId;
                isPresent = true;
            }
        });
        if (!isPresent && value.findMemberId) this.lookUpMemberId.push(value);
    }
    getLookUpMemberId() {
        return this.lookUpMemberId;
    }
    clearLookupMemberId() {
        this.lookUpMemberId = [];
    }
    setDispositionPayload(payload: any) {
        this.dispositionPayload = payload;
    }
    getDispositionPayload() {
        return this.dispositionPayload;
    }
    setDispositionNotes(note: any) {
        this.dispositionNotes = note;
    }
    getDispositionNotes() {
        return this.dispositionNotes;
    }

    setCurrentMenu(value: any) {
        // console.log(value, 'Value');
        this.currentMenu.next(value);
    }

    setisMenulinkClicked(value: any) {
        this.isMenulinkClicked.next(value);
    }

    getCurrentMenu() {
        return this.currentMenu;
    }

    setmodifiedQueueData(event: any) {
        this.modifiedQueueData = event;
    }

    getmodifiedQueueData() {
        return this.modifiedQueueData;
    }

    getselectedQueueId(value) {
        return this.selectedQueueId;
    }

    setselectedQueueId(value) {
        this.selectedQueueId.next(value);
    }

    LOADING_STARTED = 'qbrappLoadingStarted';
    LOADING_COMPLETE = 'qbrappLoadingComplete';
    WRAPPER_READY = 'qbrappWrapperReady';
    APP_PARAMS_UPDATED = 'qbrApp_appParamsUpdated';

    pendingLoads = 0;
    clientAppParams: any = null;
    wrapperReady = false;
    notificationDisplay = null;

    setClientAppParams(params: any) {
        if (!this.clientAppParams) {
            this.clientAppParams = new Object();
        }
        if (!params) params = new Object();
        //loop through the properties on the params object and set the values
        // This will prevent nulling out or deleting params that aren't passed.
        // That way we can retain values without having to query them every time getUser is called
        for (const key in params) this.clientAppParams[key] = params[key];
        //a5.cl.plugins.InactivityLogout.instance().maxMinutes(params.InactivityTimeout || 60);
        //cls.dispatchEvent(QBRApp.APP_PARAMS_UPDATED, params);
    }

    getEnvironmentTLD() {
        switch (environment.environment) {
            case 'DEV':
                return 'dev';
            case 'TEST':
                return 'test';
            case 'STAGE':
                return 'stage';
            default:
                return 'com';
        }
    }

    getPod() {
        return environment.pod;
    }

    getApplication() {
        return environment.application;
    }
    getUserLoggedout() {
        return this.isUserloggedout;
    }
    setUserLoggedout(val: boolean) {
        this.isUserloggedout = val;

        if (val) {
            blockGetUserCalls = true;
            this.stopUserHeartbeat();
        }
    }

    adjustTimer() {
        const currentUrl = window.location.href.toLocaleLowerCase();
        const matchFound = this.pagenames.some(name => currentUrl.includes(name));

        if (matchFound) {
            this.defaultgetusertimerValue = 10000; // decrease interval if match (10 sec)
        } else {
            this.defaultgetusertimerValue = 20000; // increase interval if no match (20 sec)
        }
        // console.log('Timer value', this.defaultgetusertimerValue);
    }

    // =========================================================
    //  START / STOP
    // =========================================================

    /**
     * Call ONCE after login / softphone init.
     * Do not call repeatedly - the service guards against double-start,
     * but a single explicit call keeps the lifecycle obvious.
     */
    public startUserHeartbeat(): void {

        blockGetUserCalls = false;
        getUserErrorCount = 0;
        getUser400ErrorCount = 0;
        this.isUserloggedout = false;
        this.keepAlive.start();
        this.networkIssueActive = false;
        this.networkAlertShown = false;
        this.clearNetworkOfflineTimer();

        this.adjustTimer();
        console.log('[Heartbeat] Using worker:', this.heartbeat.isUsingWorker());
        this.heartbeat.start(
            () => this.sendGetUser(),            // work performed on each tick
            () => this.canSendGetUser(),         // guard evaluated before each tick
            this.defaultgetusertimerValue,       // normal period
            20000,                               // retry period when hub not joined
            60000                                // watchdog: force-release window
        );
    }

    /** Stop the heartbeat. Called on logout, session expiry and ngOnDestroy. */
    public stopUserHeartbeat(): void {
        this.heartbeat.stop();
        this.keepAlive.stop();

        this.clearNetworkOfflineTimer();
        this.networkIssueActive = false;
        this.networkAlertShown = false;

        // Reset application state during logout/teardown.
        // This does not programmatically close an already-rendered dialog,
        // but prevents further network dialogs.
        this.networkAlertDialogOpen = false;
    }

    /** True when the heartbeat is currently running (diagnostics). */
    public isHeartbeatRunning(): boolean {
        return this.heartbeat.isRunning();
    }

    // =========================================================
    //  TICK HANDLERS
    // =========================================================

    /** Decides whether this tick should proceed. */
    private canSendGetUser(): boolean {
        return !blockGetUserCalls &&
            !this.isUserloggedout;
    }


    /** Performs the actual heartbeat request. */
    private sendGetUser(): void {
        this.adjustTimer();
        this.heartbeat.setInterval(this.defaultgetusertimerValue);
        this.keepAlive.pulse();

        if (blockGetUserCalls || this.isUserloggedout) {
            this.heartbeat.requestSkipped();
            return;
        }

        /*
         * navigator.onLine === false means the browser believes it is
         * definitely offline. Skip this tick, but do not stop the worker.
         */
        if (navigator.onLine === false) {
            console.warn(
                '[getUser] Browser offline. Skipping this heartbeat tick.'
            );
            this.networkIssueActive = true;
            this.scheduleNetworkOfflineAlert();
            this.heartbeat.requestSkipped();
            return;
        }

        if (this.getUserRequestActive) {
            this.heartbeat.requestSkipped();
            return;
        }

        this.getUserTrigger$.next();
    }

    private readonly offlineHandler = (): void => {
        if (
            blockGetUserCalls ||
            this.isUserloggedout
        ) {
            return;
        }

        console.warn(
            '[getUser] Browser is offline. ' +
            'Heartbeat remains active.'
        );

        this.networkIssueActive = true;
        this.scheduleNetworkOfflineAlert();
    };

    //Trigger an immediate ping when the network returns
    private readonly onlineHandler = (): void => {

        this.clearNetworkOfflineTimer();

        // Reset only when the network genuinely returns.
        this.networkIssueActive = false;
        this.networkAlertShown = false;

        if (
            blockGetUserCalls ||
            this.isUserloggedout ||
            this.getUserRequestActive
        ) {
            return;
        }

        console.log(
            '[getUser] Network restored. Triggering immediate heartbeat.'
        );

        getUserErrorCount = 0;
        getUser400ErrorCount = 0;

        if (!this.heartbeat.isRunning()) {
            this.startUserHeartbeat();
            return;
        }

        //this.getUserTrigger$.next();
        this.getUser();
    };

    public prepareForLogout(): void {
        this.isUserloggedout = true;
        blockGetUserCalls = true;
        this.stopUserHeartbeat();
    }
    // =========================================================
    //  CALLBACKS
    //  IMPORTANT: requestCompleted() MUST be called on every path,
    //  otherwise the in-flight guard will block all future ticks.
    // =========================================================

    successCallback = function (data) {
        this.networkFailureCount = 0;
        getUserErrorCount = 0;
        getUser400ErrorCount = 0;
        this.networkIssueActive = false;
        this.networkAlertShown = false;
        this.clearNetworkOfflineTimer();
        this.LastGetUsercalledtime = new Date();
        requiredtoCheckallCondition = false;

        this.getusercalledcount++;

        if (data.Response.Status != 13) {

            if (data.Response.User) {

                getUserLastPingExceedCount = 0;

                try {


                    if (!data.Response.IsUserActiveinHub &&
                        !this.hubService.getIsHubStarted()) {

                        this.hubService.setTMHubJoinedStatus(false);
                        this.hubService.setIsHubStarted(true);
                        this.hubManager.CallHubManager(this.hubService.getuserDetails());
                    }

                    if ($.connection.hub.state && $.connection.hub.state == 4) {
                        this.hubManager.start(this.hubService.getuserDetails())
                            .then(() => { })
                            .catch(err =>
                                console.error('Error starting SignalR connection:', err));
                    }

                } catch (e) { }

            } else {

                if (localStorage.getItem('clientAbbreviation')) {
                    blockGetUserCalls = true;
                    this.stopUserHeartbeat();
                    this.callSessionExpired('1');

                } else if (localStorage.getItem('clientAbbreviation') == null) {
                    blockGetUserCalls = true;
                    this.stopUserHeartbeat();
                    this.callSessionExpired('1');
                }
            }

        } else {
            // User ping table not updated - allow up to 5 attempts.
            getUserLastPingExceedCount++;

            if (getUserLastPingExceedCount > 5) {
                blockGetUserCalls = true;
                this.stopUserHeartbeat();
                this.callSessionExpired('3');

            } else {
                const getstatus = this.getAgentStatus();
                this.setUserStatus(getstatus, this.queueServices.getselectedQueueId()
                );
            }
        }

        // No rescheduling here - the heartbeat worker owns the timer.
    };

    errorCallback = function (
        errorCode: any,
        details: any
    ): void {
        const status = Number(
            details?.status ?? errorCode ?? 0
        );

        const isConnectivityError =
            status === 0 ||
            navigator.onLine === false;

        console.log(
            '[getUser] Error. Status:',
            status,
            'Browser online:',
            navigator.onLine,
            'Message:',
            details?.message
        );

        // Temporary connectivity failure:
        // keep heartbeat active and retry automatically.
        if (isConnectivityError) {

            console.warn(
                '[getUser] Connectivity unavailable. ' +
                'Heartbeat remains active and will retry.'
            );
            this.networkIssueActive = true;
            this.scheduleNetworkOfflineAlert();
            return;
        }

        getUserErrorCount++;

        if (status === 400) {
            getUser400ErrorCount++;
        }

        if (getUser400ErrorCount >= 5) {
            blockGetUserCalls = true;
            this.isUserloggedout = true;
            this.stopUserHeartbeat();
            this.callSessionExpired('4', status);
            return;
        }

        if (status >= 500 && getUserErrorCount >= 5) {
            blockGetUserCalls = true;
            this.isUserloggedout = true;
            this.stopUserHeartbeat();
            this.callSessionExpired('6', status);
            return;
        }

        if (getUserErrorCount >= 5) {
            blockGetUserCalls = true;
            this.isUserloggedout = true;
            this.stopUserHeartbeat();
            this.callSessionExpired('2', status);
        }
    };

    getUser(): void {
        if (blockGetUserCalls || this.isUserloggedout) {
            return;
        }

        if (!this.heartbeat.isRunning()) {
            this.startUserHeartbeat();
            return;
        }

        this.sendGetUser();
    }
    private scheduleNetworkOfflineAlert(): void {
        /*
         * Do not schedule another timer when:
         * - a timer is already active; or
         * - the alert was already shown for this outage.
         */
        if (
            this.networkOfflineTimer !== null ||
            this.networkAlertShown || this.networkAlertDialogOpen
        ) {
            return;
        }

        this.networkOfflineTimer = setTimeout(() => {
            this.networkOfflineTimer = null;

            if (
                this.networkIssueActive &&
                !blockGetUserCalls &&
                !this.isUserloggedout &&
                !this.networkAlertShown && !this.networkAlertDialogOpen
            ) {
                this.networkAlertShown = true;
                this.showNetworkOfflineAlert();
            }
        }, this.NETWORK_ALERT_DELAY_MS);
    }
    private clearNetworkOfflineTimer(): void {
        if (this.networkOfflineTimer !== null) {
            clearTimeout(this.networkOfflineTimer);
            this.networkOfflineTimer = null;
        }
    }
    private showNetworkOfflineAlert(): void {

        // Final protection against duplicate dialogs.
        if (this.networkAlertDialogOpen) {
            return;
        }

        const message =
            'The network connection has been unavailable ' +
            'for several minutes. Please check your network ' +
            'or VPN connection. It will automatically ' +
            'retry when connectivity is restored.';

        this.confirmDialogComponent
            .confirmdialog(
                '',
                message,
                'OK',
                ''
            )
            .then(() => {
                // Dialog has been closed by clicking OK.
                this.networkAlertDialogOpen = false;

                /*
                 * Informational only.
                 *
                 * Do not:
                 * - reset networkAlertShown;
                 * - stop the heartbeat;
                 * - set blockGetUserCalls;
                 * - set the user to disconnected;
                 * - log the user out.
                 *
                 * If the network has already returned, request
                 * an immediate ping.
                 */
                if (
                    navigator.onLine &&
                    !blockGetUserCalls &&
                    !this.isUserloggedout &&
                    !this.getUserRequestActive
                ) {
                    this.getUserTrigger$.next();
                }

                /*
                    * If this is now a NEW offline period that started while the
                    * old dialog was open, allow a fresh 5-minute monitoring cycle.
                    */
                if (
                    navigator.onLine === false &&
                    this.networkIssueActive &&
                    !blockGetUserCalls &&
                    !this.isUserloggedout
                ) {
                    this.networkAlertShown = false;
                    this.scheduleNetworkOfflineAlert();
                }

            })
            .catch(() => {

                // Dialog was closed using ESC, browser navigation,
                // cross icon, or another supported dismiss action.
                this.networkAlertDialogOpen = false;

                /*
                 * Back, ESC, cross-button, or dialog dismissal
                 * must not stop automatic recovery.
                 */
                console.log(
                    '[getUser] Network alert dismissed. ' +
                    'Automatic recovery remains active.'
                );

                if (
                    navigator.onLine === false &&
                    this.networkIssueActive &&
                    !blockGetUserCalls &&
                    !this.isUserloggedout
                ) {
                    this.networkAlertShown = false;
                    this.scheduleNetworkOfflineAlert();
                }

            });
    }
    getUser1() {
        this.adjustTimer();
        //console.log('getuser method called');
        clearTimeout(this.getUserInterval);
        if (!blockGetUserCalls) {
            if (this.hubService.getTMHubJoinedStatus()) {
                // console.log('Hub before calling getUser():, hub id:', ($?.connection?.hub?.id ? $?.connection?.hub?.id : 'empty'));
                this.getUserTrigger$.next();
            }
            else {
                // TMHubJoinFailed++;
                this.getUserInterval = setTimeout(this.getUser.bind(this), 20000);
            }

        }
    }
    successCallback1 = function (data) {

        getUserErrorCount = 0;
        this.LastGetUsercalledtime = new Date();
        requiredtoCheckallCondition = false;

        this.getusercalledcount++;

        if (data.Response.Status != 13) {
            if (data.Response.User) {

                getUserLastPingExceedCount = 0;

                try {
                    if (!this.hubService.getTMHubJoinedStatus()) {
                        TMHubJoinFailed++;
                    } else {
                        TMHubJoinFailed = 0;

                    }

                    if (TMHubJoinFailed >= 2 && TMHubJoinFailed <= 10) {
                        $.connection.hub.state = 4;
                        $.connection.hub.stop();

                        this.hubManager.start(this.hubService.getuserDetails()).then(() => {
                            console.log('SignalR connection established successfully!');
                            // You can now interact with the hub, e.g., call server methods

                        })
                            .catch(err => console.error('Error starting SignalR connection:', err));

                    } else if (TMHubJoinFailed > 10) {
                        this.callReloginAlert('');
                    }

                    if (!data.Response.IsUserActiveinHub && !this.hubService.getIsHubStarted()) {//&& !this.hubService.getIsHubStarted()
                        this.hubService.setTMHubJoinedStatus(false);
                        this.hubService.setIsHubStarted(true);
                        //$.connection.hub.state = 4;
                        //$.connection.hub.stop();
                        this.hubManager.CallHubManager(this.hubService.getuserDetails());

                    }

                    if ($.connection.hub.state && $.connection.hub.state == 4) {
                        this.hubManager.start(this.hubService.getuserDetails()).then(() => {
                            //  console.log('SignalR connection established successfully!');
                            // You can now interact with the hub, e.g., call server methods
                            // this.signalrService.invokeServerMethod('SendMessage', 'Hello from Angular!');
                        })
                            .catch(err => console.error('Error starting SignalR connection:', err));
                        //console.log('getUser called, connection.hub.state disconnected and hugmanager called to start' + $.connection.hub.state);
                    }
                } catch (e) { }
                //  callback(data.Response.User);

            } else {
                const user = localStorage.getItem('user') || {};
                if (localStorage.getItem('clientAbbreviation')) {
                    blockGetUserCalls = true;
                    this.callSessionExpired('1', '');

                } else if (localStorage.getItem('clientAbbreviation') == null) {
                    blockGetUserCalls = true;
                    this.callSessionExpired('1', '');
                }
            }
        }
        else {//if user ping table not updated, trying to reach for 5 attempt
            getUserLastPingExceedCount++;
            if (getUserLastPingExceedCount > 5) {
                blockGetUserCalls = true;
                this.callSessionExpired('3', '');
            }
            else {
                var getstatus = this.getAgentStatus();
                this.setUserStatus(getstatus, this.queueServices.getselectedQueueId());
                //  console.log('expired ping table:'+getstatus);
            }
        }

        this.getUserInterval = setTimeout(this.getUser.bind(this), this.defaultgetusertimerValue);

        //    console.log('getusercalled stopped');
    };
    errorCallback1 = function (errorCode, details) {
        getUserErrorCount++;
        if (errorCode.toLowerCase().includes('400')) {
            getUser400ErrorCount++;
        }
        if (getUserErrorCount < 5) this.getUserInterval = setTimeout(this.getUser.bind(this), this.defaultgetusertimerValue);
        else {
            blockGetUserCalls = true;

            //alert('Your session has ended or An unexpected error has occurred.  Click OK to log back in.');
            //this.userService.logout();
            if (getUser400ErrorCount >= 5) {
                console.log('400 bad request, Status: ' + status);
                this.callSessionExpired('4', '');
            } else {
                console.log('An unexpected error has occurred.Click OK to log back in Status: ' + status);
                this.callSessionExpired('2', '');
            }

            //errorCallback('Invalid Response');
        }

        //console.log(this.getUserInterval, 'userrrrr');
        this.setUserInterval(this.getUserInterval);
    };
    getAgentStatus() {
        return this.ProfileInfo.getAgentStatus();
    }
    getClientAppParams() {
        if (this.clientAppParams == null) {
            this.clientAppParams = this.webStorageService.getItemFromSessionStorage('loginParams');
        }
        return this.clientAppParams;
    }
    //due to signalR not joined to server, sending message to agent to relogin post cookie removed
    callReloginAlert(alertmsg) {
        var msg = 'Due to signalR not connected with server, Kindly relogin post cookie removed. Click Ok to logout';
        this.confirmDialogComponent
            .confirmdialog('', msg, 'OK', '')
            .then(confirmed => {
                if (confirmed) {
                    this.userService.logout();
                } else {
                    //Reject the call
                }
            })
            .catch(() =>
                console.log(
                    'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                )
            );
    }
    callSessionExpired(alertmsg, statusCode?: any) {
        var msg = '';
        if (alertmsg == '1') {
            msg = 'Your session has ended. Click OK to log back in.';

        } else if (alertmsg == '2') {
            msg = 'An unexpected error has occurred. Click OK to log back in.';

        } else if (alertmsg == '3') {
            msg = 'Your session has ended. Click OK to log back in..';

        } else if (alertmsg == '4') {
            msg = 'Your session has ended. Click OK to log back in...';

        } else if (alertmsg == '5') {
            msg = 'We are unable to reach the server. Please check your network ' +
                'connection and click OK to log back in.';

        } else if (alertmsg == '6') {
            msg = 'The service is temporarily unavailable. Please click OK to ' +
                'log back in. If the issue continues, contact support.';
        }

        // Append the reference code when one is available.
        if (statusCode !== undefined && statusCode !== null && statusCode !== '') {
            msg += ` (Reference: ${statusCode})`;
        }

        //clearInterval(this.getUserInterval);
        // Stop the worker heartbeat (replaces the old clearInterval).
        this.stopUserHeartbeat();

        this.isUserloggedout = true;
        this.setUserStatus(3, null);
        this.confirmDialogComponent
            .confirmdialog('', msg, 'OK', '')
            .then(confirmed => {
                if (confirmed) {
                    this.stopUserHeartbeat();
                    this.userService.logout();
                } else {
                    //Reject the call
                }
            })
            .catch(() =>
                console.log(
                    'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                )
            );
    }
    setUserInterval(value: any) {
        this.userIntervelValue = value;
    }
    getUserIntervalValue() {
        return this.userIntervelValue;
    }
    setSelectedQueueName(value: any) {
        this.ProfileInfo.setQueueName(value);
        this.selectedQueueName.next(value);
    }

    setSelectedQueueType(value: any) {
        this.ProfileInfo.setInteractionType(value);
        this.selectedQueueType.next(value);
    }
    setCaseUserDetail(value: any) {

        this.CaseUserDetail.next(value);
    }
    SetQueueInfo(queue: string) {
        this.queueInfoSource.next(queue);
    }
    setTTSPlaying(value: boolean) {
        this.ttsPlaying.next(value);
    }

    setSelectedCampaignId(value: any) {
        this.selectedCampaignId.next(value);
    }

    setSelectedCampaignName(value: any) {
        this.selectedCampaignName.next(value);
    }

    setupdatedImageURL(value: any) {
        this.updatedImageURL.next(value);
    }

    setActivityId(value: any) {
        this.activityId.next(value);
    }

    setActionItemId(value: any) {
        this.actionItemId.next(value);
    }
    setTransferCaseID(value: number) {
        this.transferCaseID.next(value);
    }
    setUserStatus(statusID: any, queueID: any) {
        this.ProfileInfo.setUserStatus(statusID, queueID);
    }
    setSoftPhoneStatus(softPhoneStatus: any) {
        this.ProfileInfo.setSoftPhoneStatus(softPhoneStatus);
    }
    setAgentStatus(status: any) {
        this.ProfileInfo.setAgentStatus(status);
    }
    setblockGetUserCalls(value: any) {
        blockGetUserCalls = value;
        // Keep the heartbeat consistent with the flag.
        if (value === true) {
            this.stopUserHeartbeat();
        }
    }
    setPhoneClient(client, useSoftPhone) {
        this.ProfileInfo.setPhoneClient(client, useSoftPhone);
    }
    setRecordingAgentScreen(value: any) {
        this.isRecordingAgentScreen.next(value);
    }
    getRecordingAgentScreen() {
        return this.isRecordingAgentScreen.value;
    }
    setConfirmationStatus(status: boolean): void {
        this.isConfirmed = status;
    }

    getConfirmationStatus(): boolean {
        return this.isConfirmed;
    }
    setSearchParameters(value: any) {
        this.searchParameters = value;
    }
    getSearchParameters() {
        return this.searchParameters;
    }

    EnableTranscriptTab(item) {
        if (this.TransriptTab.value != item) this.TransriptTab.next(item);
    }
    SetTranscriptId(interactionId, Postcalltranscription) {
        this.TranscriptDetails.next({ interactionId: interactionId, isPostcalltranscription: Postcalltranscription });
    }
    setIsCaseEdit(value) {
        this.isCaseEdit.next(value);
    }
    setIsCasesReload(value) {
        this.casesReload.next(value);
    }
    setIsAddNewUser(value: boolean): void {
        this.isAddNewUser = value;
    }
    getIsAddNewUser(): boolean {
        return this.isAddNewUser;
    }

    setGetUsercalledtime(value) {
        this.LastGetUsercalledtime = value;
    }
    getGetUsercalledtime() {
        return this.LastGetUsercalledtime;
    }

    ChecklastgetuserCalled() {
        // console.log('getuser()->this.LastGetUsercalledtime', this.LastGetUsercalledtime)
        if (this.LastGetUsercalledtime == undefined) {
            this.LastGetUsercalledtime = new Date();
        }
        var sec = this.getMinutesDifference(this.LastGetUsercalledtime ?? new Date(), new Date())
        // console.log('getuser called in seconds', sec)
        if (sec > 12) {
            this.hubService.setTMHubJoinedStatus(true);
            this.setGetUsercalledtime(new Date());
            this.getusercalledcount = 0;
            this.getUser();

        }
    }

    getMinutesDifference(date1, date2) {
        const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
        // const diffInMinutes = diffInMilliseconds / 60000;
        const diffInsec = diffInMilliseconds / 1000;
        return Math.round(diffInsec); // Or Math.floor(diffInMinutes) for whole minutes
    }
    getSoftPhoneStatus() {
        return this.ProfileInfo.getSoftPhoneStatus();

    }
    setIsMachineDetection(value: boolean): void {
        this.isMachineDetection = value;
    }
    getIsMachineDetection(): boolean {
        return this.isMachineDetection;
    }

    setAIAuditEnabled(value: any) {
        sessionStorage.setItem('aiAuditEnabled', value ? 'true' : 'false');
        this.aiAuditEnabled.next(value);
    }

    getAIAuditEnabled(): any {
        return this.aiAuditEnabled.value;
    }

    setEnableTemplateButton(value: any) {
        this.enableTemplateButton.next(value);
    }

    setEnableAICaseNotesTemplate(value: any) {
        this.enableAICaseNotesTemplate.next(value);
    }

    setHasOpenedQNX(val: boolean) {
        this.hasOpenedQNX = val;
    }

    getHasOpenedQNX() {
        return this.hasOpenedQNX;
    }

    ngOnDestroy(): void {
        window.removeEventListener('online', this.onlineHandler);
        window.removeEventListener('offline', this.offlineHandler);
        this.stopUserHeartbeat();
        this.getUserSub?.unsubscribe();
        this.getUserTrigger$.complete();

    }
}
